import { render, staticRenderFns } from "./PDisplayProduct.vue?vue&type=template&id=4ebab3ea"
import script from "./PDisplayProduct.vue?vue&type=script&lang=js"
export * from "./PDisplayProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports